export const clickableMixin = (superclass) =>
  class ClickableMixinClass extends superclass {
    get isLoading() {
      return this.getAttribute('loading') === 'true';
    }

    click() {
      this.isLoading || super.click();
    }
  };
